import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SUB_TYPE, USER_TYPE } from 'src/app/core/Constants/static';
import { RuleConfigDetails, RuleConfigListing } from 'src/app/core/Models/interfaces/ruleconfig';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { RuleConfigManageService } from '../../services/rule-config-manage.service';
import { ClientRuleService } from '../../services/client-rule.service';
import { Pagination } from 'src/app/core/Models/interfaces/pagination';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rule-configuration-details',
  templateUrl: './rule-configuration-details.component.html',
  styleUrls: ['./rule-configuration-details.component.css']
})
export class RuleConfigurationDetailsComponent implements OnInit {

  public showSlider: boolean = false;
  user?: UserDetails | null;
  showConfigurationEdit: boolean = false;
  isAddPage: boolean = false;
  ruleConfigDetails!: RuleConfigDetails[];
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input('selectedConfig') selectedConfig!: RuleConfigListing | undefined;
  @Output() editPage: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectedItem: EventEmitter<RuleConfigListing | undefined> = new EventEmitter<RuleConfigListing | undefined>();
  drugInHand: any[] = [];
  limitDisQuanty!: string;
  refill!: string;
  calBasedOn!: string;
  maxDuration!: string;
  isLoader: boolean = false;
  page_no: number = 1;
  showNavigation: boolean = false;
  page_limit: number = 10;
  totalCount!: number;
  considerDrugInHand!: string;
  dispenseType!: string;
  subType = environment.subscriberType;
  @Input('systemConfigView') systemConfigView: boolean = false;
  constructor(private userService: UserService,
    private systemRuleService: ClientRuleService,
    private ruleService: RuleConfigManageService) {
    this.user = this.userService.getUserInfo()?.userDetails;
  }

  ngOnInit(): void {
    this.getRuleConfigDetails();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.showSlider = true;
    }, 100);
  }
  getRuleConfigDetails() {
    if (!this.systemConfigView) {
      if (this.selectedConfig?.subscriberType == 'payer' || this.selectedConfig?.payerId) {
        this.isLoader = true;
        let id = this.selectedConfig?.SubscriberId || this.selectedConfig?.payerId;
        let versionId = this.selectedConfig?.versionId || this.selectedConfig?.payerRuleConfigurationVersionId;
        this.ruleService.getRuleConfigDetailsPayer(id, versionId).subscribe({
          next: (response) => {
            if (response) {
              this.ruleConfigDetails = response?.data?.data;
              this.setRuleConfigValues();
              this.isLoader = false;
            }
          },
          error: (error) => {
            this.isLoader = false;
          },
        })
      } else {
        this.isLoader = true;
        let id = this.selectedConfig?.SubscriberId || this.selectedConfig?.providerId;
        let versionId = this.selectedConfig?.versionId || this.selectedConfig?.providerRuleConfigurationVersionId;

        this.ruleService.getRuleConfigDetailsProvider(id, versionId).subscribe({
          next: (response) => {
            if (response) {
              this.ruleConfigDetails = response?.data?.data;
              this.setRuleConfigValues();
              this.isLoader = false;
            }
          },
          error: (error) => {
            this.isLoader = false;
          },
        })
      }
    } else {
      this.getSystemDetails()
    }
  }
  getDrugInHand() {
    let payload = {
      per_page: this.page_limit,
      page: this.page_no,
    }
    this.ruleService.getDrugInHandExpiry(payload).subscribe({
      next: (response) => {
        if (response) {
          this.drugInHand = response?.data?.data;
          this.totalCount = response?.data?.total;
          if (!this.drugInHand?.length) this.showNavigation = true;
          this.isLoader = false;
        }
      },
      error: (error) => {
        this.isLoader = false;
      },
    })
  }
  currentPageDetail(event: Pagination) {
    if (event) {
      this.page_no = event?.button_no;
      this.page_limit = event?.item_per_page;
    }
    this.getDrugInHand();
  }
  public configurationEdit() {
    setTimeout(() => {
      this.showSlider = false;
    });

    this.editPage.emit(true);
    this.selectedItem.emit(this.selectedConfig);

  }
  closePopup() {
    this.close.emit()
  }
  getSystemDetails() {
    this.isLoader = true;
    let id = this.selectedConfig?.clientId;
    let versionId = this.selectedConfig?.ruleConfigurationVersionId;
    this.systemRuleService.getSystemRuleConfigDetails(versionId).subscribe({
      next: (response) => {
        if (response) {
          this.ruleConfigDetails = response?.data?.data;
          this.setRuleConfigValues();
          this.isLoader = false;
        }
      },
      error: (error) => {
        this.isLoader = false;
      },
    });
  }

  checkPermission(perName: string): boolean {
    return this.userService.getPermissions(perName);
  }

  private setRuleConfigValues(): void {
    this.ruleConfigDetails?.forEach((el) => {
      if (el?.configCode == 'LMTDISPQUNTY') {
        this.limitDisQuanty = el?.configValue as string;
      } else if (el?.configCode == 'ALLOWREFILL') {
        this.refill = el?.configValue as string;
        // }else if(el?.configCode == 'Calculation Based On'){
        //    this.calBasedOn =el?.configValue;
      } else if (el?.configCode == 'MAXREFILL') {
        this.maxDuration = el?.configValue as string;
      } else if (el?.configCode === 'DRUGSELECTION') {
        this.calBasedOn = el?.configValue as string;
      } else if (el?.configCode == 'CONSIDER_DRUG_IN_HAND_METAKEY') {
        this.considerDrugInHand = el?.configValue as string;
      }
      else if (el?.configCode == 'DISPENSETYPE_METAKEY') {
        this.dispenseType = el?.configValue as string;
      }

    })

  }
  setProviderPayer(): string {
    let head = 'Linked Provider / Payer';
    if (this.subType == SUB_TYPE.provider) {
      head = 'Linked Provider';
    }
    else if (this.subType == SUB_TYPE.payer) {
      head = 'Linked Payer';
    } else {
      if (this.user?.userType == USER_TYPE.payer) {
        head = 'Linked Payer';
      }
      else if (this.user?.userType == USER_TYPE.provider) {
        head = 'Linked Provider';
      }
    }
    return head;
  }
}
